import { Response } from '@/app/system/response/Response';
import { Loading } from '@/app/system/process/Loading';
import { Guest } from '@/app/system/guest/Guest';
import { PatronPool } from '@/app/system/guest/PatronPool';
import { Patron } from '@/app/system/guest/Patron';
import { GuestDynamic } from '@/app/system/guest/GuestDynamic';
import { PatronPoolWithGuests } from '@/app/system/guest/PatronPoolWithGuests';

const cache = new Map();
let responsesQueued: Record<string, PatronPool<any>> = {};

export const resetResponseCache = () => {
  cache.clear();
  responsesQueued = {};
};

export class ResponseCached<T> implements Response<T>, Guest<T> {
  private withLoading = new Loading();
  private poolWithGuests = new PatronPoolWithGuests(this);

  public constructor(private baseResponse: Response<T>) {}

  content(guest: Guest<T>): Loading {
    this.baseResponse.id(new GuestDynamic(id => {
      if (cache.has(id)) {
        const value = cache.get(id);
        guest.receive(value);
        this.poolWithGuests.receive(value);
        return this.withLoading;
      }

      if (!responsesQueued[id]) {
        responsesQueued[id] = new PatronPool(this);
        this.baseResponse.content(new Patron(new GuestDynamic(value => {
          responsesQueued[id].receive(value);
        })));
      }

      responsesQueued[id].add(new Patron(this));
      this.poolWithGuests.add(guest);
      this.withLoading.receive(true);
    }));

    return this.withLoading;
  }

  id(guest: Guest<string>) {
    guest.receive('cache');
    return this;
  }

  introduction() {
    return 'guest' as const;
  }

  receive(value: T) {
    this.withLoading.receive(false);
    this.baseResponse.id(new GuestDynamic(id => {
      cache.set(id, value);
      this.poolWithGuests.receive(value);
    }));
    return this;
  }
}
